package dev.inmo.wishlist.features.ui.topBar.ui

import dev.inmo.wishlist.features.common.client.models.ViewConfig
import kotlinx.serialization.Serializable

/** Navigation config for the top bar slot of the scaffold. */
@Serializable
class TopBarViewConfig : ViewConfig
